import request from '../utils/request';

// 手机号码登录获取验证码
export function smsSend(params) {
    return request.MainService({
        url: '/api/sms/send',
        method: 'post',
        data: params
    });
}

// 登录
export function login(params) {
    return request.MainService({
        url: '/ddilearner/v1/user/login',
        method: 'post',
        data: params
    });
}

// 登出
export function logout(params) {
    return request.MainService({
        url: '/ddilearner/v1/user/logout',
        method: 'get',
        params: params
    });
}

// 判断是否多设备同时登陆
export function userinfo(params) {
    return request.MainService({
        url: '/ddilearner/v1/user/userinfo',
        method: 'get',
        params: params
    });
}

/**
 * 获取心跳间隔
 */
export function intervalValue() {
    return request.MainService({
        url: '/ddilearner/v1/user/loginstatus/interval',
        method: 'get',
        data: {} 
    });

}







// WEBPACK FOOTER //
// ./src/api/user.js